import type { SVGProps } from 'react';

const MobileLoadingHero = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 375 189.5" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={202.5} cy={125.5} fill="#fd6a46" r={55.5} />
    <path d="m4654 239 76 25 101 103h-177z" fill="#57939b" transform="translate(-4654 -178)" />
    <path
      d="m4801.555 264.272c32.681-30.632 122.245-101.372 227.445-73.617v97.674h-142s-94.283-15.774-85.445-24.057z"
      fill="#054b54"
      transform="translate(-4654 -102.329)"
    />
    <path
      d="m-.338 561.8s37.5-4.7 72 31.3 70.5 74.078 98.5 81.9h204.5v-38.082s-28-15.129-72 16.172-109 1.043-128.5-16.172-58-67.818-80.5-95.988-59.5-55.429-94-55.429z"
      fill="#478f9a"
      transform="translate(.338 -485.5)"
    />
    <path d="m4654.5 309.909s106.684-17.926 183 62.091h-183z" fill="#d3eaec" transform="translate(-4654.5 -183.193)" />
  </svg>
);
export default MobileLoadingHero;
